import {
  getRequiredAiProvidersForRepositoryIndexingMode,
  type RepositoryIndexingMode,
} from "@arti/shared-source-control/indexing/runMode";

export interface RepositoryIndexingModeOption {
  description: string;
  label: string;
  value: RepositoryIndexingMode;
}

export interface RepositoryModeSelectionInput {
  mode: RepositoryIndexingMode;
  repository_slug: string;
}

export const REPOSITORY_INDEXING_MODE_OPTIONS: readonly RepositoryIndexingModeOption[] =
  [
    {
      description: "Generate repo embeddings and repository insights.",
      label: "Embedding + Indexing",
      value: "embedding_and_indexing",
    },
    {
      description: "Only refresh vector embeddings for semantic search.",
      label: "Embedding Only",
      value: "embedding_only",
    },
    {
      description: "Only run repository profile and insight indexing.",
      label: "Indexing Only",
      value: "indexing_only",
    },
  ];

export function getModeOption(
  mode: RepositoryIndexingMode,
): RepositoryIndexingModeOption {
  return (
    REPOSITORY_INDEXING_MODE_OPTIONS.find((option) => option.value === mode) ??
    REPOSITORY_INDEXING_MODE_OPTIONS[0]
  );
}

export function resolveMissingProvidersForSelections(
  selections: readonly RepositoryModeSelectionInput[],
  missingProviders: readonly string[],
) {
  const missingSet = new Set(missingProviders);
  const requiredProviders = new Set<string>();

  for (const selection of selections) {
    for (const provider of getRequiredAiProvidersForRepositoryIndexingMode(
      selection.mode,
    )) {
      if (missingSet.has(provider)) {
        requiredProviders.add(provider);
      }
    }
  }

  return Array.from(requiredProviders).toSorted((left, right) =>
    left.localeCompare(right),
  );
}

export function resolveRepositoryModeLabel(mode: RepositoryIndexingMode) {
  return getModeOption(mode).label;
}
